import React, { useEffect, useState } from "react";
import useMarkAttendance from "../hooks/useMarkAttendance";
import { Grid, Skeleton, Switch } from "@mantine/core";
import { FaUser } from "react-icons/fa";
import { BsCheckCircle, BsXCircle } from "react-icons/bs";
import { EButton } from "../../../../../../libs/ui";

type IProps = {
  isLoading: boolean;
  teacherListForAttendance: any[];
  teacherMarkAttendanceList: any[];
  handleAttendanceChange: (index: number, event: any) => void;
  handleSubmitAttendance: () => void;
};
export default function MarkNewAttendance({
  isLoading,
  teacherListForAttendance,
  handleAttendanceChange,
  handleSubmitAttendance,
  teacherMarkAttendanceList,
}: IProps) {
  //   console.log("teacherMarkAttendanceList", teacherMarkAttendanceList);
  const [eligibleSlot, setEligibleSlot] = useState(false);
  const [slotTime, setSlotTime] = useState(
    "The next attendance slot is: 8:00 am to 10:00 am"
  );

  const timeSlots = [
    { start: 8, end: 10, label: "8:00 am - 10:00 am" },
    { start: 14.5, end: 16.5, label: "2:30 pm - 4:30 pm" },
  ];


  // Define the check function
  function checkAttendance(attendanceData: any) {
    const targetDate = new Date(); // Today's date
    const currentHour = targetDate.getHours();
    const currentMinute = targetDate.getMinutes();
    const currentTime = currentHour + currentMinute / 60; // Current time in decimal format


    // Find the current time slot if it exists
    const currentSlot = timeSlots.find(
      (slot) => currentTime >= slot.start && currentTime < slot.end
    );

    if (!currentSlot) {
      setEligibleSlot(true);
      return;
    }

    // Check if there's attendance marked for today in the current time slot
    const attendanceMarked = attendanceData.some((record: any) => {
      const attendanceDate = new Date(record.attendance_Date);

      // Check if the attendance date is today
      if (
        attendanceDate.getDate() === targetDate.getDate() &&
        attendanceDate.getMonth() === targetDate.getMonth() &&
        attendanceDate.getFullYear() === targetDate.getFullYear()
      ) {
        // Convert attendance hour and minute into decimal form
        const attendanceHour = attendanceDate.getHours();
        const attendanceMinute = attendanceDate.getMinutes();
        const attendanceTime = attendanceHour + attendanceMinute / 60;

        // Check if the attendance time falls within the current slot
        return (
          attendanceTime >= currentSlot.start &&
          attendanceTime < currentSlot.end
        );
      }
      return false;
    });

    if (!attendanceMarked) {
      setEligibleSlot(false);
    } else {
      setEligibleSlot(true);
    }
  }


  // Function to find the next available time slot
  function getNextAttendanceSlot() {
    const currentDate = new Date();
    const currentHour = currentDate.getHours();
    const currentMinute = currentDate.getMinutes();
    const currentTime = currentHour + currentMinute / 60;

    // Check if the current time is within any active slot
    const activeSlot = timeSlots.find(
      (slot) => currentTime >= slot.start && currentTime < slot.end
    );

    if (activeSlot) {
      setSlotTime(`The current attendance slot is active: ${activeSlot.label}`);
    } else {
      // Find the first slot where the end time is after the current time
      const nextSlot = timeSlots.find((slot) => currentTime < slot.start);

      if (nextSlot) {
        setSlotTime(`The next attendance slot is: ${nextSlot.label}`);
      } else {
        setSlotTime("No more attendance slots available for today.");
      }
    }
  }

  useEffect(() => {
    getNextAttendanceSlot();
    checkAttendance(teacherMarkAttendanceList);
  }, [teacherMarkAttendanceList]);

  return (
    <>
      {isLoading ? (
        <Skeleton height={190} radius="md" />
      ) : (
        <>
          <Grid className="flex">
            <Grid.Col>
              <div>
                <p className="mt-2 font-semibold">Available Slot</p>
                {slotTime}
              </div>
            </Grid.Col>
          </Grid>{" "}
          {teacherListForAttendance?.map((each, index) => (
            <Grid className="flex">
              <Grid.Col span={3} className="flex gap-3 mt-3 ">
                <div className="bg-slate-300 rounded-xl p-3 w-12 h-12 items-center justify-center">
                  <FaUser size={25} />
                </div>
                <div>
                  <p className="font-semibold text-md">{each?.employee_Name}</p>
                  <p className="text-sm">{each?.employee_Code}</p>
                </div>
              </Grid.Col>
              <Grid.Col span={2}>
                <div>
                  <p className="mt-2 font-semibold">Designation</p>
                  {each?.designation}
                </div>
              </Grid.Col>
              <Grid.Col span={2}>
                <Switch
                  checked={each?.is_Present}
                  onChange={(event) => handleAttendanceChange(index, event)}
                  color={"green"}
                  size="md"
                  disabled={eligibleSlot}
                  label={each?.is_Present ? "Present" : "Absent"}
                  styles={{
                    track: {
                      backgroundColor: each?.is_Present ? undefined : "red",
                      borderColor: each?.is_Present ? undefined : "red",
                    },
                  }}
                />
              </Grid.Col>
            </Grid>
          ))}
          <Grid>
            <Grid.Col span={4}></Grid.Col>
            <Grid.Col span={1}>
              <div className="flex gap-2">
                <EButton onClick={() => {}} className="btn-light">
                  Cancel
                </EButton>
                <EButton
                  onClick={() => handleSubmitAttendance()}
                  className="btn-blue"
                  disabled={eligibleSlot}
                >
                  Submit Attendance
                </EButton>
              </div>
            </Grid.Col>
          </Grid>
        </>
      )}
    </>
  );
}
